import { axiosModules } from "@qubit-utill/src";

export default {
  // filters > 필터 분류 > 필터 분류 목록 가져오기
  getFilterCategoryList: (filterCategoryType) => axiosModules.get(`/pfilter/filtercategory/${filterCategoryType}`),
};
